import script from "./Wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=02801e12&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02801e12"]])

export default __exports__